export default {"mobile-shop":{},"global":{"project":"测试项目名称","boundaryErrorTitle":"哎呀，出错了！","apologize":"抱歉，应用程序遇到了一些问题。","retry":"重试","noData":"暂无数据"}}